import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import Swal from "sweetalert2";
import ImageCropper from "../crop_image/ImageCropper";

function ProgramAdd() {
    const navigate = useNavigate();

    const [formValue, setFormValue] = useState({
        cover_foto: null,
        foto_slider: null,
        foto_slider2: null,
        foto_slider3: null,
        foto_slider4: null,
        foto_slider5: null,
        foto_slider6: null,
        title: "",
        penjelasan: "",
    });

    const [preview, setPreview] = useState({
        cover_foto: null,
        foto_slider: null,
        foto_slider2: null,
        foto_slider3: null,
        foto_slider4: null,
        foto_slider5: null,
        foto_slider6: null,
    });

    const [cropData, setCropData] = useState({
        isOpen: false,
        imageSrc: null,
        imageType: "",
    });

    const [croppedImage, setCroppedImage] = useState(null);

    // ✅ Buka cropper dengan validasi hanya gambar
    const openCropper = (file, imageType) => {
        // Daftar tipe gambar yang diperbolehkan
        const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp", "image/gif"];

        if (!allowedTypes.includes(file.type)) {
            Swal.fire({
                title: "File tidak valid",
                text: "Hanya file gambar (JPG, JPEG, PNG, WEBP, GIF) yang diperbolehkan!",
                icon: "warning",
            });
            return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setCropData({
                isOpen: true,
                imageSrc: reader.result,
                imageType,
            });
        };
    };

    const closeCropper = () => {
        setCropData({
            isOpen: false,
            imageSrc: null,
            imageType: "",
        });
        setCroppedImage(null);
    };

    const applyCrop = () => {
        if (croppedImage instanceof Blob) {
            const blobUrl = URL.createObjectURL(croppedImage);
            setFormValue({
                ...formValue,
                [cropData.imageType]: croppedImage,
            });
            setPreview({
                ...preview,
                [cropData.imageType]: blobUrl,
            });
        } else {
            console.error("Cropped image is not a Blob:", croppedImage);
        }
        closeCropper();
    };

    const handleChange = (event) => {
        const { name, files } = event.target;
        if (files && files.length > 0) {
            const file = files[0];
            openCropper(file, name);
        } else {
            setFormValue({
                ...formValue,
                [name]: event.target.value,
            });
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!formValue.title || !formValue.penjelasan) {
            Swal.fire({
                title: "Error",
                text: "Semua field teks harus diisi",
                icon: "error",
            });
            return;
        }

        const requiredImages = [
            "cover_foto",
            "foto_slider",
            "foto_slider2",
            "foto_slider3",
            "foto_slider4",
            "foto_slider5",
            "foto_slider6",
        ];

        const emptyImages = requiredImages.filter((field) => !formValue[field]);

        if (emptyImages.length > 0) {
            Swal.fire({
                title: "Error",
                text: "Semua foto wajib diunggah!",
                icon: "error",
            });
            return;
        }

        const FormDataInput = new FormData();
        requiredImages.forEach((field) => {
            FormDataInput.append(field, formValue[field]);
        });

        FormDataInput.append("title", formValue.title);
        FormDataInput.append("penjelasan", formValue.penjelasan);

        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            axios.interceptors.request.use(
                (config) => {
                    config.headers.authorization = `Bearer ${token}`;
                    return config;
                },
                (error) => Promise.reject(error)
            );

            await axios.post(
                `${process.env.REACT_APP_API_URL}/program/createProgram`,
                FormDataInput,
                {
                    headers: { "Content-Type": "multipart/form-data" },
                }
            );

            Swal.fire({
                title: "Sukses",
                text: "Data berhasil ditambahkan",
                icon: "success",
            });
            navigate("/program");
        } catch (error) {
            Swal.fire({
                title: "Error",
                text: "Data gagal ditambahkan",
                icon: "error",
            });
            console.error("Gagal menambahkan data:", error.response?.data || error.message);
        }
    };

    return (
        <div>
            <Header />
            <Navbar />
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Tambah Program</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item">
                                        <Link to="/">Administrasi</Link>
                                    </li>
                                    <li className="breadcrumb-item active">Program</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Tambah Program</h3>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            <div className="form-group">
                                                <label>Judul</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="title"
                                                    placeholder="Masukkan Judul"
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label>Penjelasan</label>
                                                <textarea
                                                    className="form-control"
                                                    name="penjelasan"
                                                    placeholder="Masukkan Penjelasan"
                                                    onChange={handleChange}
                                                ></textarea>
                                            </div>

                                            {/* === COVER FOTO === */}
                                            <div className="form-group">
                                                <label>Cover Foto</label>
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    name="cover_foto"
                                                    accept="image/*"
                                                    onChange={handleChange}
                                                />
                                                {preview.cover_foto && (
                                                    <div className="preview-container-program">
                                                        <img
                                                            src={preview.cover_foto}
                                                            alt="Preview"
                                                            className="preview-image-program"
                                                        />
                                                    </div>
                                                )}
                                            </div>

                                            {/* === FOTO SLIDER 1–6 === */}
                                            {[
                                                "foto_slider",
                                                "foto_slider2",
                                                "foto_slider3",
                                                "foto_slider4",
                                                "foto_slider5",
                                                "foto_slider6",
                                            ].map((fieldName, index) => (
                                                <div className="form-group" key={index}>
                                                    <label>{`Foto Slider ${index + 1}`}</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        name={fieldName}
                                                        accept="image/*"
                                                        onChange={handleChange}
                                                    />
                                                    {preview[fieldName] && (
                                                        <div className="preview-container-program">
                                                            <img
                                                                src={preview[fieldName]}
                                                                alt="Preview"
                                                                className="preview-image-program"
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            ))}

                                            <div className="form-group">
                                                <button type="submit" className="btn btn-info">
                                                    Simpan
                                                </button>
                                                <Link to="/program">
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary ml-2"
                                                    >
                                                        Batal
                                                    </button>
                                                </Link>
                                            </div>
                                        </form>

                                        {/* Modal Cropper */}
                                        {cropData.isOpen && (
                                            <ImageCropper
                                                imageSrc={cropData.imageSrc}
                                                setCroppedImage={setCroppedImage}
                                                onCropComplete={applyCrop}
                                                onClose={closeCropper}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default ProgramAdd;
